import React from 'react';
import '../../styles/aboutUs-page/accentSection/AccentSection.min.css';

const y4clogo = '/images/aboutUs-page/y4clogo.svg'
const AccentSection = () => {
    return (
        <div className='about-us-page-accent-section d-flex justify-content-center align-items-center flex-column'>
                <img src={y4clogo} alt='Youth for Change' className='img-fluid my-5 bg-transp'/>
            </div>
    );
}

export default AccentSection;